<template>
  <ButtonOptions
    :modelValue="reservation.status"
    :options="statusItems"
    :buttonRules="buttonRules"
    itemText="label"
    itemValue="status"
    @update:modelValue="$emit('setReservationStatus', $event as ReservationStatusType)"
  >
    <template #option="option">
      <span :id="`option-${option.value.split(' ').join('-')}`" class="flex items-center space-x-2">
        <span :class="[option.bgColor]" class="w-3 h-3 block rounded-full" />
        <span class="">{{ option.label }}</span>
      </span>
    </template>
  </ButtonOptions>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue'

import ButtonOptions from '@/common/components/organisms/ButtonOptions.vue'

import { ReservationDetailedRead, ReservationStatus, ReservationStatusType } from '@generated/types'

interface StatusItem {
  label: string
  status: ReservationStatusType
  bgColor: string
  classes?: string
}

export default defineComponent({
  name: 'ReservationStatusDropdown',
  components: { ButtonOptions },
  props: {
    reservation: {
      type: Object as PropType<ReservationDetailedRead>,
      required: true,
    },
  },
  data() {
    return {
      statusItems: [
        {
          label: ReservationStatus.EXPECTED,
          status: ReservationStatus.EXPECTED,
          bgColor: 'bg-status-expected',
        },
        { label: 'pending', status: 'unpaid', classes: 'hidden', bgColor: 'bg-status-noshow' },
        {
          label: ReservationStatus.ARRIVED,
          status: ReservationStatus.ARRIVED,
          bgColor: 'bg-status-waiting',
        },
        {
          label: ReservationStatus.SEATED,
          status: ReservationStatus.SEATED,
          bgColor: 'bg-status-seated',
        },
        {
          label: ReservationStatus.NO_SHOW,
          status: ReservationStatus.NO_SHOW,
          bgColor: 'bg-status-noshow',
        },
        {
          label: ReservationStatus.CANCELED,
          status: ReservationStatus.CANCELED,
          bgColor: 'bg-status-noshow',
        },
        {
          label: ReservationStatus.CLEARED,
          status: ReservationStatus.CLEARED,
          bgColor: 'bg-status-available',
        },
      ] as StatusItem[],
      buttonRules: {
        expected: { when: ReservationStatus.EXPECTED, then: 'Seat', end: ReservationStatus.SEATED },
        seated: { when: ReservationStatus.SEATED, then: 'clear', end: ReservationStatus.CLEARED },
      },
    }
  },
  emits: {
    // eslint-disable-next-line no-unused-vars
    setReservationStatus: (status: ReservationStatusType) => true,
  },
})
</script>
